import { SitioOportunity } from '../../../utils/global'
import { formatCurrency } from '../../../utils/helpMain';
import { catRelationship } from './MochaData'

const isValidObject = (obj: any) => (obj !== undefined && obj !== null);
const roundToTwo = (value: number, decimals = 2): number => (Number(Math.round(parseFloat(value.toString() + 'e' + decimals)) + 'e-' + decimals));


const BuildDataOportunity = (data: IVidaCR, source: string | null) => {
    const dataOportunity = {
        Sitio: SitioOportunity.CR.VidaAutoExpedible,
        NombreCompleto: `${data.name1} ${data.name2} ${data.lastname1} ${data.lastname2}`,
        Celular: data.cellPhoneNumber,
        TipoIdentificacion: data.typeDocument,
        Identificacion: data.identification,
        Edad: data.age,
        OrigenOportunidad: source,
        IdPoliza: 0
    }
    return dataOportunity;
}

const BuildDataNotificationOportunitySL = (data: IVidaCR) => {
    let dataNotification = { sitio: SitioOportunity.CR.VidaAutoExpedible, values: {} }
    const values: Record<string, string> = {
        "{{nombres}}": `${data.name1} ${data.name2} ${data.lastname1} ${data.lastname2}`,
        "{{identificacion}}": data.identification,
        "{{correoasegurado}}": data.email,
        "{{celular}}": data.cellPhoneNumber,
        "{{oportunidad}}": '',
    }
    dataNotification.values = values;
    return dataNotification;
}

const BuildDataPolicy = (data: IVidaCR) => {
    let lstBeneficiary: any = [];
    let lstAnswers: any = [];
    let polCobs: any = [];
    let polCobsDesc: any = [];
    let lstOAKitSpecial: Array<OA_EquipoEspecial> = [];
    let oa: any = {}

    const resumen = data.lstRateResumen[parseInt(data.planSelected) - 1]
    const frecuency = data.catQuotas.find(x => x.value === data.nQuotas)?.text2 ?? ''

    console.log(data)

    let policy: any = {
        Plan: data.plan,
        SA: resumen.sumInsured,
        Prima: resumen.bonus,
        Descuento: resumen.desc,
        PrimaDE: resumen.bonus,
        PrimaNeta: resumen.bonus2,
        PrimaExonerada: 0,
        Impuesto: resumen.tax,
        Total: resumen.total,
        Frecuencia: frecuency,
        Cuotas: data.nQuotas,
        Estado: 0,
        mInteres: resumen.financing,
        DerechoEmision: resumen.rightEmission
    }

    oa = {
        SA: resumen.sumInsured,
        peFnacimiento: data.birthdate,
        peIngreso: data.monthlyIncome,
        peIngresoMoneda: "U$",
        pePeso: 1,
        peEstatura: 1,
        peEdadAct: data.age
    }

    let insured = {
        TipoId: data.typeDocument,
        NumId: data.identification,
        Nombre: `${data.name1} ${data.name2}`,
        Apellido: `${data.lastname1} ${data.lastname2}`,
        TelefonoCelular: data.cellPhoneNumber,
        Email: data.email,
        Sexo: data.sex,
        EstadoCivil: 0,
        FechaNacimiento: data.birthdate,
        NombreEmp: data.company,
        TelefonoEmp: data.companyPhone,
        OrigenFondos: data.originFunds,
        OrigenFondosDetalle: data.originFundsExplained,
        Profesion: data.profession,
        Direccion: data.address,
        Pais: data.nationality,
        Departamento: data.province,
        Municipio: data.canton,
        Distrito: data.district,
        Barriada: data.neighborhood,
        IngresoMensual: data.monthlyIncome
    }

    const rates = data.lstRate[parseInt(data.planSelected) - 1].RateLst;

    rates.map((rate: IRates) => {
        let nameCover = data.catCoverages.find(x => x.idCob === rate.idCob);
        let tempCover: any = {};
        let prima = roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1));
        let primaDE = 0;
        let pRecargo = 0;
        let mRecargo = 0;
        if (nameCover !== undefined) {

            let porcenDescount = 0;
            let desc = 0
            let idDesc = 0;
            if (rate.pRecargo > 0) {
                pRecargo = rate.pRecargo;
                mRecargo = roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100)));
            }
            if (porcenDescount > 0) {
                let primaDesc = parseFloat(rate.prima);
                desc = roundToTwo((prima) * (porcenDescount / 100))
            }
            primaDE = roundToTwo(prima - desc);


            let Etiqueta = '0';

            tempCover['Nombre'] = nameCover.nombre;
            tempCover['orden'] = nameCover.orden;
            tempCover["IdCob"] = rate.idCob;
            tempCover["SA"] = rate.sa;
            tempCover["Prima"] = prima;//roundToTwo(parseFloat(rate.prima) * ((rate.pRecargo / 100) + 1));
            tempCover["ptasa"] = rate.pTasa;
            tempCover["pdescuento"] = porcenDescount;
            tempCover["mdescuento"] = desc;
            tempCover["pRecargo"] = 0;
            tempCover["mRecargo"] = 0;
            tempCover["mprimabruta"] = primaDE;
            tempCover["PrimaDE"] = primaDE;
            tempCover["Etiqueta"] = Etiqueta;
            tempCover["bDescuentoManual"] = 0;
            tempCover["PrimaGravada"] = primaDE
            tempCover["COA"] = rate.coa || 0
            tempCover["Deducible"] = rate.deducible || 0
            polCobs.push(tempCover);
        }
    })

    data.lstBeneficiary.map((x) => {
        let descRelationShip = catRelationship.find(r => r.value === x.relationship)?.text ?? ''
        let benef = {
            nombre: `${x.name1} ${x.name2} ${x.lastname1} ${x.lastname2}`,
            parentesco: x.relationship,
            xparentesco: descRelationShip,
            menor: false,
            participacion: x.percentage,
            repLegal: ``,
            cedula: x.identification,
            bprincipal: false
        }
        lstBeneficiary.push(benef);
    })

    policy['Respuesta'] = lstAnswers;
    policy['Beneficiarios'] = lstBeneficiary;
    policy['PolCobs'] = polCobs;
    policy['PolCobsDesc'] = polCobsDesc;
    policy['Oa'] = oa;
    policy['Asegurado'] = insured;
    policy['FormaPagos'] = {};

    return policy;

}

const BuildPayment = (data: IVidaCR) => {
    return {
        policyId: data.polizaid,
        cardHolder: data.cardName,
        cardNumber: data.cardNumber,
        cvv: data.cardCVV,
        expirationDate: data.cardExpirationDate,
        amountApp: data.feePay,
        currencyApp: GetCurrecyPV(data.plan),
        email: data.email
    }
}

const BuildSaveCard = (data: IVidaCR) => {
    return {
        tarjeta: data.cardNumber,
        tipoTarjeta: data.cardType,
        correo: data.email,
        celular: data.cellPhoneNumber,
        asegurado: `${data.name1} ${data.name2} ${data.lastname1} ${data.lastname2}`,
        vencimiento: data.cardExpirationDate,
        poliza: data.cnpoliza,
        transactionId: data.transactionId,
        titularTarjeta: data.cardName,
        acepta: true,
        bancoEmisor: data.issuingBank
    }
}


const GetCurrecyPV = (plan: string) => ((plan.trim() === '610') ? 'U$' : '¢')

const BuildNotification = (data: IVidaCR, code: string, interno: boolean = false) => {

    let dataNotification = { sitio: SitioOportunity.CR.VidaAutoExpedible, codigo: code, values: {}, adjuntos: [] as Array<IFileDto> }

    let nationality = data.catNationality.find(x => x.value.toString() === data.nationality.toString());
    let profession = data.catProfession.find(x => x.value.toString() === data.profession.toString())

    const values: Record<string, string> = {
        'interno': interno.toString(),
        "correo": data.email,
        '{{oferta}}': data.polizaid,
        '{{nombres}}': `${data.name1} ${data.name2} ${data.lastname1} ${data.lastname2}`,
        '{{identificacion}}': data.identification,
        '{{correoasegurado}}': data.email,
        '{{celular}}': data.cellPhoneNumber,
        '{{nacionalidad}}': nationality?.text ?? '',
        '{{profesion}}': profession?.text ?? '',
        '{{moneda}}': GetCurrecyPV(data.plan),
        '{{oportunidad}}': data.oportunity,
        '{{plan}}': (parseInt(data.planSelected) + 1).toString(),
        '{{fechaTransaccion}}': '',
        '{{horaTransaccion}}': '',
        '{{poliza}}': '',
        '{{numeroTarjeta}}': '',
        '{{codAutorizacion}}': '',
        '{{montoPagado}}': '',
    }
    dataNotification.values = values;
    return dataNotification;
}

const BuildNotificationPol = (data: IVidaCR, code: string) => {
    let dataNotification = { sitio: SitioOportunity.CR.VidaAutoExpedible, codigo: code, values: {}, adjuntos: [] as Array<IFileDto> }

    const values: Record<string, string> = {
        'correo': data.email,
        "idpoliza": data.polizaid.toString(),
        "tiporeporte": 'pol',
        "nombrereporte": `Poliza ${data.cnpoliza}`,
        '{{nombres}}': `${data.name1} ${data.name2} ${data.lastname1} ${data.lastname2}`,
        '{{poliza}}': data.cnpoliza
    }

    dataNotification.values = values;
    return dataNotification;
}

const BuildCardNum = (tarjeta: string) => {
    if (tarjeta.length < 4) {
        return tarjeta;
    }
    const ultimos4 = tarjeta.slice(-4);
    const oculto = '*'.repeat(tarjeta.length - 4);
    return oculto + ultimos4;
}

const GetHour = (date: Date) => {
    let hora = date.getHours();
    const minutos = date.getMinutes().toString().padStart(2, '0');
    const segundos = date.getSeconds().toString().padStart(2, '0');

    const ampm = hora >= 12 ? 'PM' : 'AM';
    
    hora = hora % 12;
    hora = hora ? hora : 12; 

    return `${hora}:${minutos}:${segundos} ${ampm}`;
}

const GetFormatMoneyFeePay = (data: IVidaCR) => {
     const currency = data.planConfig.moneda.trim()
     return formatCurrency(currency, parseFloat(data.feePay))
}

export {
    BuildDataNotificationOportunitySL,
    BuildDataOportunity,
    BuildDataPolicy,
    BuildPayment,
    roundToTwo,
    BuildSaveCard,
    BuildNotification,
    BuildNotificationPol,
    BuildCardNum,
    GetHour,
    GetFormatMoneyFeePay
}